// extracted by mini-css-extract-plugin
export var info = "DeductionsInformation-module--info--6d8db";